export { SplitFactory } from './splitFactory';
export { InLocalStorage } from '@splitsoftware/splitio-commons/esm/storages/inLocalStorage/index';
export { ErrorLogger } from '@splitsoftware/splitio-commons/esm/logger/browser/ErrorLogger';
export { WarnLogger } from '@splitsoftware/splitio-commons/esm/logger/browser/WarnLogger';
export { InfoLogger } from '@splitsoftware/splitio-commons/esm/logger/browser/InfoLogger';
export { DebugLogger } from '@splitsoftware/splitio-commons/esm/logger/browser/DebugLogger';
